import React, {useEffect, useState} from 'react';
import UserContextState from "./utils/context/user/userContextStateConfig";
import { BrowserRouter } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";
import { userInfoFromJwtRequest } from "./utils/request/api";
import LanguageContextState from './utils/context/i18n/languageContextStateConfig';
import CacheBuster from 'react-cache-buster';
import pjson from '../package.json';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import { MAINTENANCE } from './config/env';
import MaintenanceImage from '../src/assets/img/maintenance.png';
import { MaintenancePage } from '@bge/global_solution_workbench_commons';
import RestrictedPage from './components/MaintenancePage/RestrictedPage';
import DashboardFiltersContextState from './utils/context/dashboardFilters/dashboardFiltersContextStateConfig';

const getUserInfoFromJwt = async() => {
    const token = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const hideProfile = localStorage.getItem("hideProfile");
  
    if(token && refreshToken){
      const response = await userInfoFromJwtRequest(token, refreshToken);
      if (response.status === 200){
        let user = response.user
        if (!user.lastProfile && user.profiles.length){
            user.lastProfile = user.profiles[0].id
        }
        if (hideProfile) {
            user.hideProfile = true;
        }
        return {user: user, isAuth: true, error: ""};
      }
      // refresh token expired
      if (response.status === 401){
        return {user: null, isAuth: false, error: response.error}
      }
      // service down
      return {user:null, isAuth: false, error: response.error}
    };
    // no tokens in local storage
    return {user: null, isAuth: false, error: ""};
};


const App = () => {

    const [startingState, setStartingState] = useState({user: null, isAuth: false, error: ""});
    const [loading, setLoading] = useState(true);
    const [loadingImages, setLoadingImages] = useState(true);

    useEffect( () => {
        (async () => {
            const start = await getUserInfoFromJwt();
            setStartingState(start);
            setLoading(false);
        })();
    }, []);

    useEffect(() => {
        if(MAINTENANCE){
            const img = new window.Image();
            img.src = MaintenanceImage;
            img.onload = () => setLoadingImages(false);
        }
    }, []);

    if(false){
       return (
            <LanguageContextState>
                <RestrictedPage />
            </LanguageContextState>
        )
    }else if(!loading){
        return (
            <CacheBuster
                currentVersion={pjson.version}
                isEnabled={true}
                isVerboseMode={false}
                loadingComponent={
                    <LoadingScreen />
                }
                metaFileDirectory={'.'}
            >
                {
                    MAINTENANCE !== "false" ? 
                        loadingImages ? 
                        <LoadingScreen /> 
                        : 
                        <MaintenancePage image={MaintenanceImage} />
                    :
                    <LanguageContextState >
                        <UserContextState start={startingState}>
                            <DashboardFiltersContextState>
                                <BrowserRouter>
                                    <ScrollToTop />
                                    <HomePage />
                                </BrowserRouter>
                            </DashboardFiltersContextState>
                        </UserContextState>
                    </LanguageContextState>
                }
            </CacheBuster>
        );
    };
    return <LoadingScreen />
};


export default App;